<template>
	<cookie-law buttonText="Det er greit">
		<div slot="message" class="cookie__wrapper">
			<span class="cookie__info">
				Denne nettsiden bruker informasjonskapsler for nettsidens funksjonalitet, samt statistikk om besøkendes
				samhandling med nettsiden.
			</span>

			<router-link class="cookie__link text-small" to="/personvern">Les mer</router-link>
		</div>
	</cookie-law>
</template>

<script>
import CookieLaw from 'vue-cookie-law'
export default {
	components: { CookieLaw },
}
</script>

<style lang="scss">
@import '@/styles/base/_color.scss';
@import '@/styles/base/_variables.scss';
@import '@/styles/base/_typography.scss';
@import '@/styles/components/vue-elder-button';

.cookie {
	&__link {
		white-space: nowrap;
		justify-self: end;
		margin: 0 1rem;
		@include respond-below('tablet') {
			justify-self: start;
		}
	}

	&__wrapper {
		display: flex;
		justify-content: space-between;
		flex-grow: 1;
	}
}

.Cookie {
	&__buttons {
		margin-left: 1rem;
	}

	&__content {
		flex-grow: 1;
	}

	justify-content: flex-start;
}

.Cookie--base .Cookie__button {
	padding: 0.5rem 1.5rem !important;

	@extend .elder-button;
	@extend .elder-button--secondary;
	background: transparent !important;
	border-color: $dark-grey !important;
	color: $dark-grey !important;
	margin: 0;
}
.Cookie--base .Cookie__button:hover {
	background: transparent !important;
}
.Cookie--base {
	padding: 1rem 2rem;
	@extend .text-micro;
	color: $dark-grey !important;
	background-color: $primary !important;
}
</style>
